module.exports = __webpack_public_path__ + "static/media/folderoutline.953c41d5.svg";